import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { MenuApi } from "../../api";
import { Spin, Button, Tooltip, Form, Input, Drawer } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useLang } from "../../hooks/useLang";
import ManSearchingIcon from '../../../src/assets/images/icon/search.png';

type Props = {
    parentId: number;
};

const MenuWidget: React.FC<Props> = (props: Props) => {
    const { t, lang, getLangUrl } = useLang();
    const { parentId } = props;

    const [listData, setListData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);

    const showDrawer = () => {
        setIsDrawerVisible(true);
    };

    const handleCancel = () => {
        setIsDrawerVisible(false);
    };

    useEffect(() => {
        if (parentId) {
            loadMenuList(parentId);
        }

    }, [parentId])

    const loadMenuList = (parentId): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            const payload = {
                $select: "id,title_en,title_bn,url,slug,sort_order,status",
                $filter: `parent_id eq '${parentId}' AND status eq 1`,
                $orderby: "sort_order asc",
            }
            MenuApi.list(payload)
                .then((res) => {
                    setListData(res.data.data.results);
                    setLoading(false);
                    resolve(res);
                })
                .catch((err) => {
                    setLoading(false);
                    reject(err);
                });
        });
    };

    return (
        <>
            {loading && <Spin size="small" />}
            <ul>
                {listData?.map((item, index) => (
                    <li key={index}>
                        {item.slug && (
                            <Link to={getLangUrl(lang, item.slug)}>
                                {lang === 'en' ? item.title_en : item.title_bn}
                            </Link>
                        )}
                        {item.url && (
                            <a href={item.url}>
                                {lang === 'en' ? item.title_en : item.title_bn}
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </>
    )
}

export default React.memo(MenuWidget);
